<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
        <div class="col-xs-2 col-sm-1"></div>
        <div class="col-xs-10 col-sm-10">
            <div class="row">
                <h4 class="text-left" >Les contrats</h4>
                <br>
            </div>
            <div class="row my-4">
                <router-link class="btn btn-primary pull-left " :to="{name: 'ContratsNew'} ">Nouveau contrat </router-link>   
            </div>
                <ul  v-if="pageCount > 1" class="pagination pagination-sm no-margin pull-right justify-content-center">
                    <li class="page-item"  v-if="showFirstPageIndex"><a class="page-link" href="#" @click="pageClicked(1)">1</a></li>
                    <li class="page-item"  v-if="showLessDots"><a class="page-link" href="#" @click="currentPage = startPaginatorIndex - 1">...</a></li>
                    <li class="page-item" v-for="n in pageRange" :key="n" :class="{active : n == currentPage}"><a class="page-link"  href="#" @click="pageClicked(n)">{{n}}</a></li>
                    <li class="page-item"  v-if="showMoreDots"><a class="page-link" href="#" @click="currentPage = endPaginatorIndex + 1">...</a></li>
                    <li class="page-item"  v-if="showLastPageIndex" @click="pageClicked(pageCount)"><a class="page-link" href="#">{{this.pageCount}}</a></li>
                </ul>
                    <div class="table-responsive row voffset5">
                    <table class="table table-striped">
                        <thead>
                        <tr>        
                            <th>#</th>
                            <th>Remplacé</th>
                            <th>Remplaçant</th>
                            <th>Dates</th>               
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="contrat in allContrats.edges" :key="contrat.node.id">          
                            <th scope="row">{{ contrat.node.id }}</th>
                            <td class="text-left">{{ contrat.node.titulaireByTitulaireId.nom }}</td>
                            <td class="text-left">{{ contrat.node.remplacantByRemplacantId.nom }}</td>
                            <td class="text-left">{{ contrat.node.setDatesFields }}</td>
                            <td><router-link class='btn btn-primary pull-right' :to="{name: 'ContratsEdit', params: { id: contrat.node.id}}">Editer</router-link> </td>
                            <!-- <td><router-link class='btn btn-primary pull-right' :to="{name: 'ContratsPrint' , params: { id: contrat.node.id}}">Imprimer</router-link></td> -->
                            <td><button  data-toggle="modal" data-target="#myModal" class='btn btn-primary pull-right' @click="printContrat(contrat.node)">Imprimer PDF</button></td>
                            <td><button class='btn btn-danger pull-right' @click="deleteContrat(contrat.node.id)">Suppr.</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Contrats</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <span id="iframeContainer"></span>
                    <iframe height="400" width="600" :src="iframeblob">
                        <p>Your browser does not support iframes.</p>
                    </iframe>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
    </div>
</template>
<script>
import $ from 'jquery'
import AppNav from '../AppNav'
import moment from 'moment'
import _ from 'lodash'
import { CONTRATS_PER_PAGE } from '../../constants/settings'
const PDFDocument = require('pdfkit/js/pdfkit')
var blobStream  = require( 'blob-stream')
var ContratMedecin = require('../../assets/javascripts/ContratMedecin')
var ContratEtudiant = require('../../assets/javascripts/ContratEtudiant')
var ContratMedecinSel = require('../../assets/javascripts/ContratMedecinSel')
import {
    ALL_CONTRATS_QUERY,
    DELETE_CONTRAT
} from '../../constants/graphql'

const pageSize = 10

export default {
  name: 'contrats',
  components: {
    AppNav
  },
  data() {
    return {
      allContrats: [],
      iframeblob: "",
      contratsPerPage: CONTRATS_PER_PAGE,
      offset: 0,
      first: CONTRATS_PER_PAGE,
      currentPage: 1
    }
  },
  apollo: {
    allContrats: {
      query: ALL_CONTRATS_QUERY,
      variables() {
        var  offset =  this.offset
        var   first =   this.first
        return {
            offset,
            first
        }
      }
    }
  },
  computed: {
    pageCount(){
      return Math.ceil(this.allContrats.totalCount/CONTRATS_PER_PAGE)
    },

    startPaginatorIndex() {
    // plus 1 so we get 1, 11, 21...
    let startIndex = (Math.floor(this.currentPage / 10) * 10) + 1
    // startIndex can be greater than the currentPage if the currentPage is divisible by 10
    if (startIndex > this.currentPage) {
      startIndex = (Math.floor((this.currentPage - 1) / 10) * 10) + 1
    }
    return startIndex;
    },

    endPaginatorIndex() {
    let endIndex = (Math.ceil(this.currentPage / 10) * 10)
    // when endIndex is greater than the pageCount we're at the end of our range
    if (endIndex > this.pageCount) {
      endIndex = this.pageCount
    }
    return endIndex;
    },

    showLessDots() {
    if (this.currentPage > 10) {
      return true
    }
    return false
    },

    showMoreDots() {
    if (this.pageCount > 11 && (this.endPaginatorIndex !== this.pageCount)) {
      return true
      }
    return false
    },

    showFirstPageIndex() {
    if (this.currentPage > 10) {
        return true
      }
    return false
    },

    showLastPageIndex() {
    if (this.pageCount > 10 && (this.endPaginatorIndex !== this.pageCount)) {
        return true
    }
    return false
    },

    pageRange() {
        return _.range(this.startPaginatorIndex, (this.endPaginatorIndex + 1));
    // return _.range(1, this.pageCount +1);
    }
  },
  methods: {
    pageClicked: function(numPage){
      console.log("pageClicked", numPage)
      this.offset = this.contratsPerPage*(numPage -1)
      this.currentPage = numPage;
    },

    moment: function () {
        return moment()
    },
    printContrat: function (contrat) {
      var pdf = new PDFDocument({page_size: 'A4' ,  bufferPages: true})
      var stream = pdf.pipe(blobStream())
      self = this
      if (contrat.remplacantByRemplacantId.typeContrat == "Etudiant") {
          ContratEtudiant.renderContratEtudiant(contrat, pdf, stream)
            stream.on('finish', function() {
              self.iframeblob = stream.toBlobURL('application/pdf')
            });
      } else  if (!_.isNull(contrat.titulaireByTitulaireId.sel) && contrat.titulaireByTitulaireId.sel !== ''){
              ContratMedecinSel.renderContratMedecinSel(contrat, pdf, stream)
              stream.on('finish', function() {
              self.iframeblob = stream.toBlobURL('application/pdf')
          });
        } else {
              ContratMedecin.renderContratMedecin(contrat, pdf, stream)
              stream.on('finish', function() {
              self.iframeblob = stream.toBlobURL('application/pdf')
              })
        }
    },

    deleteContrat(id){
        this.$apollo.mutate({
        mutation: DELETE_CONTRAT,
        variables: {
          id: id,
        },
          refetchQueries: [{
              query: ALL_CONTRATS_QUERY,
              variables: {
                  offset: this.offset,
                  first: this.first
                  }
          }]           
        }).then((data) =>{

        }).catch((error) => {
        // Error
        console.error(error)
        })
      }
    }
  }
</script>
<style scoped>
/* Move down content because we have a fixed navbar that is 3.5rem tall */
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}
/*
 * Dashboard
 */
/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}
.medecins-form{
    padding-bottom: 60px;
}
.modal-content {
    width: 635px;
}
</style>



// WEBPACK FOOTER //
// contrats.vue?c0c9dbcc